type ServiceDreadSignal = {
  label: string
  value: string
}

type ServiceDreadPanelProps = {
  footer: string
  signals: ServiceDreadSignal[]
  status: string
  title: string
}

export function ServiceDreadPanel({ footer, signals, status, title }: ServiceDreadPanelProps) {
  return (
    <aside className="rounded-lg border border-fault-red/30 bg-background/70 p-5 shadow-phosphor">
      <div className="flex items-center justify-between gap-4 border-b border-fault-red/20 pb-4">
        <h2 className="font-mono text-sm font-semibold text-fault-red">{title}</h2>
        <p className="font-mono text-xs text-white/42">{status}</p>
      </div>
      <div className="divide-y divide-white/8">
        {signals.map((signal) => (
          <div
            key={signal.label}
            className="grid gap-2 py-4 sm:grid-cols-[6rem_1fr] lg:grid-cols-1 xl:grid-cols-[6rem_1fr]"
          >
            <p className="font-mono text-xs text-white/36">{signal.label}</p>
            <p className="text-sm leading-6 text-phosphor-ivory/76">{signal.value}</p>
          </div>
        ))}
      </div>
      <p className="border-t border-fault-red/20 pt-4 text-sm leading-7 text-white/58">{footer}</p>
    </aside>
  )
}
